module.exports = __webpack_public_path__ + "img/mobile/SmartButton/hold_spin_button@1.5x.png?1.0.6";